import { render } from "./carteras.vue?vue&type=template&id=30421844"
import script from "./carteras.vue?vue&type=script&lang=js"
export * from "./carteras.vue?vue&type=script&lang=js"
script.render = render

export default script